<template>
  <div class="station-mapping">
    <div class="station-search child-center section-item">
      <el-input placeholder="请输入城市，地区名字" v-model="inputCityName" size="large" ref="inputCityName">
        <el-button
          slot="append"
          icon="el-icon-search"
          type="primary"
          v-waves
          @click="inputCityNameChanged"
        ></el-button>
      </el-input>
    </div>
    <div class="section-item toggle-station">
      <el-tabs v-model="stationType">
        <el-tab-pane label="火车站" name="trainStation" />
        <el-tab-pane label="飞机场" name="airport" />
      </el-tabs>
    </div>

    <div class="cities-search section-item">
      <p>按条件筛选</p>
      <el-divider />

      <div class="select-province condition-item">
        <p class="label">所属省份：</p>
        <div class="content">
          <city-tags
            :cities="provincesModified"
            @getCurrentTag="setCurrentProvinceId"
            :fields="provinceTagsFields"
            ref="selectProvince"
          />
        </div>
      </div>

      <div class="dashed"></div>

      <div class="select-city condition-item">
        <p class="label">选择城市：</p>
        <div class="content">
          <city-tags :cities="cities" @getCurrentTag="currentCityChanged" ref="selectCity" />
        </div>
      </div>

      <div class="dashed"></div>

      <div class="select-apportion condition-item">
        <p class="label">是否分配：</p>
        <div class="content">
          <el-radio v-model="distributed" :label="true">已分配</el-radio>
          <el-radio v-model="distributed" :label="false">未分配</el-radio>
          <el-radio v-model="distributed" :label="'all'">全部</el-radio>
        </div>
      </div>
    </div>

    <div class="station-table section-item clearfix">
      <add-Button :height="'80px'" add-text="添加" @click.native="modifyStation(initStationForm)"></add-Button>

      <Table :columns="tableColumns" :data="stationList">
        <template slot-scope="{ row }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="modifyStation(row)"
          >编辑</Button>
        </template>
      </Table>
      <!-- page -->
      <Page
        :total="total"
        :current="pagePagination.from"
        :page-size="pagePagination.size"
        @on-change="setPaginationFrom"
        @on-page-size-change="setPaginationSize"
        show-elevator
        show-sizer
        class="pagination"
      />
    </div>

    <modify
      :requestApi="requestApi"
      :stationType="stationType"
      :formData="modifyStationForm"
      :provinces="provinces"
      ref="modifyStation"
    />
  </div>
</template>

<script>
import pagination from "@/view/mixins/pagination";
import AddButton from "@/components/AddButton/AddButton";
import CityTags from "./components/CityTags";
import Modify from "./components/Modify";

import waves from "@/directive/waves/index.js";

import {
  allProvinceSymbol,
  stationApiConfig,
  tableColumns,
  initStationForm
} from "./components/config";

export default {
  components: {
    AddButton,
    CityTags,
    Modify
  },

  directives: {
    waves
  },

  mixins: [pagination],

  data() {
    return {
      stationType: "trainStation",
      distributed: true,

      requestField: "all",

      inputCityName: "",

      modifyStationForm: {},

      initStationForm: initStationForm,

      provinceTagsFields: {
        id: "provinceId",
        name: "provinceName"
      },
      provinces: [],
      cities: [],
      currentProvinceId: "",

      setTableData: this.setStationList,
      stationList: []
    };
  },

  created() {
    this.setProvinces();
    this.initProvince();

    this.setStationList();
  },

  computed: {
    provincesModified() {
      let provincesModified = this.$js.deepClone(this.provinces);

      provincesModified.unshift(allProvinceSymbol);

      return provincesModified;
    },

    requestApi() {
      return stationApiConfig[this.stationType];
    },

    tableColumns() {
      return tableColumns[this.stationType];
    }
  },

  watch: {
    currentProvinceId: {
      // immediate: true,
      handler(newValue) {
        if (newValue === "all") return (this.requestField = "all");
        this.initCity();
        this.setCities(newValue);
      }
    },

    requestField() {
      this.resetStationList();
    },

    distributed() {
      this.resetStationList();
    },

    stationType() {
      this.resetStationList();
    }
  },

  methods: {
    setProvinces() {
      this.$api.getAllProvinces().then(res => {
        this.provinces = res;
      });
    },

    setCities(provinceId) {
      this.$api.getCitiesByProvinceId(provinceId).then(res => {
        this.cities = res;
      });
    },

    setCurrentProvinceId(province) {
      this.currentProvinceId = province.provinceId;
    },

    setStationList() {
      const params = Object.assign(this.$js.deepClone(this.pagePagination), {
        conditions: [
          { field: "cityName", value: this.requestField },
          { field: "distributed", value: this.distributed }
        ]
      });

      if (this.requestField === "all") params.conditions.shift();

      if (this.distributed === "all") params.conditions.pop();

      this.requestApi.getStationPage(params).then(res => {
        this.stationList = res.records;
        this.total = res.total;
      });
    },

    resetStationList() {
      if (this.resetPaginationFrom()) return;
      this.setStationList();
    },

    currentCityChanged(val) {
      this.inputCityName = "";
      this.requestField = val.name || this.requestField;
    },

    inputCityNameChanged() {
      this.$refs.inputCityName.focus();
      this.requestField = this.inputCityName;
    },

    initProvince() {
      this.$nextTick(_ => {
        this.$refs.selectProvince.currentCity = this.$js.deepClone(
          allProvinceSymbol
        );
      });
    },

    initCity() {
      this.$nextTick(_ => {
        this.$refs.selectCity.resetCurrentCity();
      });
    },

    modifyStation(station) {
      this.$refs.modifyStation.dialogVisible = true;
      this.modifyStationForm = this.$js.deepClone(station);
    }
  }
};
</script>

<style lang="scss" scoped>
.section-item {
  margin: 20px;
  padding: 20px;
  background: #fff;
}

.dashed {
  margin: 25px 0;
  border-bottom: 1px dashed #dcdfe6;
}

.toggle-station {
  padding: 0;
  margin: 0 20px;

  ::v-deep .el-tabs {
    .el-tabs__header {
      margin: 0;

      .el-tabs__nav-scroll {
        padding-left: 30px;

        .el-tabs__item {
          font-size: 16px;
        }
      }
    }
  }
}

.station-search {
  height: 150px;
  margin-bottom: 0;

  .el-input {
    width: 500px;

    ::v-deep .el-input__inner {
      height: 45px;
      font-size: 16px;
    }

    ::v-deep .el-input-group__append {
      background: #2c8cf0;
      color: #fff;
      font-size: 20px;
    }
  }
}

.cities-search {
  font-size: 16px;

  .condition-item {
    display: flex;

    .label {
      font-size: 14px;
      width: 80px;
      padding-top: 2px;
    }

    .content {
      flex: 1;
      border-radius: 10px;
    }
  }

  .select-province,
  .select-city {
    .label {
      padding-top: 10px;
    }

    .content {
      background: #f6f7f9;
    }
  }
}

.station-table {
  min-height: 300px;
  text-align: center;

  .add-button {
    margin-bottom: 25px;
  }

  .pagination {
    float: right;
    margin: 35px 0 20px 0;
  }
}
</style>